import {
  call, put, takeLeading, select,
} from 'redux-saga/effects';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../common/notifications/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';
import { EDIT_MRD_SETTINGS_REQUEST } from '../actions/types/DeviceSettingsActionTypes';
import {
  editMrdSettingsFailureActionCreator,
  editMrdSettingsSuccessActionCreator,
} from '../actions/DeviceSettingsActions';
import { apiEditMrdSettings } from '../../api/DeviceSettingsAPI';
import { tableLoadData } from '../../../../../common/list-table/actions/ListTableActions';
import TableDefinitions from '../../../../../common/TableDefinitions';

function* editMrdSettingsWorker(action) {
  const lang = yield select(languageSelector);
  try {
    yield call(apiEditMrdSettings, action.payload);
    yield put(editMrdSettingsSuccessActionCreator());
    yield put(tableLoadData(TableDefinitions.MRD_SETTINGS.id));
  } catch (error) {
    yield put(editMrdSettingsFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error.response.data.message || formatMessage(lang, 'notification.mrd.settings.edit.failure'),
    }));
  }
}

function* deviceSettingsWatcher() {
  yield takeLeading(EDIT_MRD_SETTINGS_REQUEST, editMrdSettingsWorker);
}

export default deviceSettingsWatcher;
export {
  editMrdSettingsWorker,
};
